module.exports = __webpack_public_path__ + "img/item01.ffa18783.png";